export default __webpack_public_path__ + "static/media/reset-icon-mobile.587f2103.png";